import * as React from "react";
import useTitleBar from "../hooks/useTitleBar.tsx";

const FallbackGlobal = ({ error, info }: { error: Error; info?: any }) => {
	console.log(error, info);
	useTitleBar({
		title: "Error",
		hideNewWindow: true,
	});
	return (
		<>
			<p>{error.message}</p>
			<pre>{error.stack}</pre>
		</>
	);
};

const FallbackLocal = ({ error, info }: { error: Error; info?: any }) => {
	console.log(error, info);
	return (
		<p>
			<span className="text-danger">Error:</span> {error.message}
		</p>
	);
};

// Icons fork: plain React error boundary. Upstream this wrapped Bugsnag's React
// plugin boundary to report crashes to ZenGM; we don't phone home, so this is a
// standard class-based boundary that just renders the fallback locally.
type Props = { children: React.ReactNode; local?: boolean };
type State = { error: Error | undefined; info: React.ErrorInfo | undefined };

export class ErrorBoundary extends React.Component<Props, State> {
	override state: State = { error: undefined, info: undefined };

	static getDerivedStateFromError(error: Error): Partial<State> {
		return { error };
	}

	override componentDidCatch(error: Error, info: React.ErrorInfo) {
		this.setState({ error, info });
	}

	override render() {
		const { error, info } = this.state;
		if (error) {
			const Fallback = this.props.local ? FallbackLocal : FallbackGlobal;
			return <Fallback error={error} info={info} />;
		}

		return this.props.children;
	}
}
